module.exports = __webpack_public_path__ + "static/media/tab2.d431a29f.png";